import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { BannerDetails, BannerDetailsVariables } from "./types/BannerDetails";
import { BannerList, BannerListVariables } from "./types/BannerList";
import {
  DynamicLinkList,
  DynamicLinkListVariables
} from "./types/DynamicLinkList";

export const bannerList = gql`
  ${pageInfoFragment}
  query BannerList(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: BannerInput
  ) {
    banners(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
    ) {
      edges {
        node {
          id
          name
          startDate
          endDate
          verticals
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;
export const useBannerListQuery = makeQuery<BannerList, BannerListVariables>(
  bannerList
);

export const bannerDetails = gql`
  ${pageInfoFragment}
  query BannerDetails(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    banner(id: $id) {
      descriptionJson
      id
      imageUrl {
        url
      }
      isSplashBanner
      name
      startDate
      endDate
      type
      verticals
      deeplinkUrl
      shortDynamicLink
      coupon {
        id
        status
        name
        code
        redeemType
        startDate
        endDate
        malls(first: $first) {
          edges {
            node {
              id
              name
              code
            }
          }
        }
      }
      couponCollection {
        id
        title
        classification
        collectionType
        status
        startDate
        endDate
      }
      mall {
        id
        name
      }
      sale {
        id
        name
        description
      }
      voucher {
        id
        code
        description
      }
      malls(after: $after, before: $before, first: $first, last: $last) {
        edges {
          node {
            id
            name
          }
        }
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
      }
      product {
        id
        name
        productType {
          id
          name
        }
      }
      collection {
        id
        name
        isPublished
        products {
          totalCount
        }
      }
      brand {
        id
        name
        legalName
      }
      category {
        id
        name
        level
        products {
          totalCount
        }
      }
      page {
        name
        type
        id
      }
    }
  }
`;
export const useBannerDetailsQuery = makeQuery<
  BannerDetails,
  BannerDetailsVariables
>(bannerDetails);

export const dynamicLinkList = gql`
  query DynamicLinkList($first: Int) {
    dynamicLinks(first: $first) {
      edges {
        node {
          id
          name
          type
        }
      }
    }
  }
`;

export const useDynamicLinkListQuery = makeQuery<
  DynamicLinkList,
  DynamicLinkListVariables
>(dynamicLinkList);
